import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import AsyncLock from 'async-lock';
import { Observable, Subject } from "rxjs";
import { User } from "../models/user";
import { Api } from "./api";

@Injectable()
export class UserService {

    private lock = new AsyncLock();
    private user: User;
    private watcher = new Subject<User>();

    constructor(
        private api: Api,
        private storage: Storage,
    ) {

    }

    public clear() {
        this.set(null);
    }

    public clearAndStore(): Promise<void> {
        this.clear();
        return this.lock.acquire('user', async () => {
            await this.storage.remove('user');
        });
    }

    public get(): User {
        return this.user;
    }

    public read(): Promise<User> {
        return new Promise<User>((resolve, reject) => {
            this.lock.acquire('user', async () => {
                let data = await this.storage.get('user');
                resolve(data ? User.createOne(data) : null);
            });
        });
    }

    public async readAndSet(): Promise<User> {
        let user = await this.read();
        this.set(user);
        return user;
    }

    public async fetch(): Promise<User> {
        let session = await this.api.getSession().toPromise();
        return session.user;
    }

    public store(user: User): Promise<void> {
        return this.lock.acquire('user', async () => {
            await this.storage.set('user', user);
        });
    }

    public set(user: User): void {
        this.user = user;
        this.watcher.next(this.user);
    }

    public setAndStore(user: User): Promise<void> {
        this.set(user);
        return this.store(user);
    }

    public watch(): Observable<User> {
        return this.watcher.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/providers/user-service.ts